module["exports"] = ["#{prefix} #{Name.last_name}", "#{Name.last_name} #{suffix}", "#{prefix} #{Name.last_name} #{suffix}"];